(() => {
  const ready = (fn) => document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn();

  const optionNameFromSelect = (select) => {
    const explicit = select?.dataset?.optionName;
    if (explicit) return explicit;
    const match = select?.name?.match(/^options\[(.+)\]$/);
    return match ? match[1] : '';
  };

  const parseColorMediaMap = (variantRoot) => {
    const script = variantRoot?.querySelector('[data-rayaal-color-media-map]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent || '{}');
    } catch (error) {
      console.warn('Rayaal: unable to read color media map.', error);
      return null;
    }
  };

  const findColorSelect = (variantRoot) => {
    return [...(variantRoot?.querySelectorAll('select') || [])].find((select) => /colou?r/i.test(optionNameFromSelect(select)));
  };

  const activateColorMedia = (variantRoot, colorValue) => {
    if (!variantRoot || !colorValue) return;
    const map = parseColorMediaMap(variantRoot);
    const mediaId = map?.[colorValue];
    if (!mediaId) return;

    const sectionId = variantRoot.dataset.section;
    const gallery = document.getElementById(`MediaGallery-${sectionId}`);
    if (gallery?.setActiveMedia) {
      gallery.setActiveMedia(`${sectionId}-${mediaId}`, true);
    }
  };

  ready(() => {
    document.body.classList.add('rayaal-theme');

    const menu = document.querySelector('[data-rayaal-mobile-menu]');
    const openButton = document.querySelector('[data-rayaal-menu-open]');
    const closeButton = document.querySelector('[data-rayaal-menu-close]');
    const setMenu = (open) => {
      if (!menu) return;
      menu.classList.toggle('is-open', open);
      menu.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.documentElement.style.overflow = open ? 'hidden' : '';
      openButton?.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    openButton?.addEventListener('click', () => setMenu(true));
    closeButton?.addEventListener('click', () => setMenu(false));
    menu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMenu(false)));
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') setMenu(false); });

    document.addEventListener('change', (event) => {
      const select = event.target.closest?.('variant-selects select');
      if (!select) return;
      if (!/colou?r/i.test(optionNameFromSelect(select))) return;
      const variantRoot = select.closest('variant-selects');
      activateColorMedia(variantRoot, select.value);
    });

    document.querySelectorAll('variant-selects').forEach((variantRoot) => {
      const colorSelect = findColorSelect(variantRoot);
      if (colorSelect) activateColorMedia(variantRoot, colorSelect.value);
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.14, rootMargin: '0px 0px -5% 0px' });
      document.querySelectorAll('[data-rayaal-reveal]').forEach((el) => observer.observe(el));
    } else {
      document.querySelectorAll('[data-rayaal-reveal]').forEach((el) => el.classList.add('is-visible'));
    }

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const parallaxItems = [...document.querySelectorAll('[data-rayaal-parallax]')];
    if (!reduceMotion && parallaxItems.length) {
      let ticking = false;
      const update = () => {
        const h = window.innerHeight;
        parallaxItems.forEach((el) => {
          const rect = el.getBoundingClientRect();
          const progress = (rect.top + rect.height / 2 - h / 2) / h;
          const speed = Number(el.dataset.rayaalParallax || 18);
          el.style.transform = `translate3d(0, ${progress * speed}px, 0) scale(1.04)`;
        });
        ticking = false;
      };
      window.addEventListener('scroll', () => {
        if (!ticking) { requestAnimationFrame(update); ticking = true; }
      }, { passive: true });
      update();
    }
  });
})();
